export default "__VITE_PUBLIC_ASSET__247a9b76__"